import { Box, Toolbar } from '@mui/material';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { RequireAuth } from '../components/dcbApp/RequreAuth';
import { AppBar } from '../components/mainFrame/AppBar';
import { AufwandDialogForm } from '../features/aufwand/save/AufwandDialogForm';
import { useMitarbeiterRole } from '../features/auth/api/auth.hook';
import { MitarbeiterRole } from '../features/auth/api/types';
import { MitarbeiterDialogForm } from '../features/mitarbeiter/save/MitarbeiterDialogForm';
import logo from '../logo.svg';

import { ExternAppProjekte } from './ExternAppProjekte';

const useGuardExternApp = () => {
  const navigate = useNavigate();
  const role = useMitarbeiterRole();

  useEffect(() => {
    if (role === MitarbeiterRole.ADMIN || role === MitarbeiterRole.INTERN) {
      console.log('NAV TO INT');
      navigate('/intern');
    }
  });
};

export const ExternApp: FC<{ hasAccessToken: boolean }> = ({ hasAccessToken }) => {
  useGuardExternApp();
  return (
    <RequireAuth loggedIn={hasAccessToken}>
      <Box
        sx={{
          height: '100vh',
          background: 'grey.50',
        }}
      >
        <AufwandDialogForm forExtern />
        <MitarbeiterDialogForm />
        <AppBar forExtern logo={<img src={logo} alt="Logo" style={{ height: '42px' }} />} />
        <Toolbar />
        <ExternAppProjekte />
      </Box>
    </RequireAuth>
  );
};
